import request from '@/utils/request'

/**
 * 查询字典数据列表
 * @param {String} dictType 字典类型
 */
export function getDictDataList(dictType) {
  return request({
    url: '/system/dict/data/type/' + dictType,
    method: 'get'
  })
}
